import React from "react";
import { DialogProps, Dialog } from "@mui/material";

export const AppBaseDialog = (props: DialogProps) => {
    const handleClose = (event, reason) => {
        if (reason && reason === "backdropClick") return;
        props.onClose(event, reason);
    };

    return (
        <Dialog
            {...props}
            onClose={handleClose}
        >
            {props.children}
        </Dialog>
    );
};